import { NgModule } from '@angular/core';

import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';

import { TranscriptTitlePipe } from './transcript-title.pipe';
import { TranslationIdMap } from './transcript-title.pipe.i18n';

@NgModule({
    declarations: [TranscriptTitlePipe],
    exports: [TranscriptTitlePipe],
    imports: [CmpsLazyI18nModule.forChild(TranslationIdMap)],
})
export class CmpsTranscriptTitleModule {}
